import { useEffect, useRef, useState } from "react";
import { UnitOfMeasuresViewModel } from "../../../viewmodels/setup/unitOfMeasures/UnitOfMeasuresViewModel";
import { connect } from "react-redux";

import * as actions from "../../../store/actions/index";
import { withRouter } from "../../../shared/utility";
import SlideOver from "../../../components/slideOver/SlideOver";
import {
  SetupActions,
  SetupPage,
  SetupTable,
  SetupTd,
} from "../../../components/setup/SetupPage";
import AuditActionLink from "../../../components/audit/AuditActionLink";
import { auditHistoriesSetupAction } from "../../../components/audit/auditEntityConfig";

function UnitOfMeasures(props) {
  const { addSnackbar, logout } = props;
  const {
    getUnitOfMeasures,
    loading,
    unitOfMeasures,
    openAddUnitOfMeasureSlideOver,
    setSlideOver,
    slideOver,
    viewUnitOfMeasureDetails,
  } = UnitOfMeasuresViewModel(logout, addSnackbar);

  var currentPage = 1;
  useEffect(() => {
    getUnitOfMeasures(null, currentPage);
  }, []);

  const [first, setFirst] = useState(1);
  const [rows, setRows] = useState(20);
  const searchRef = useRef();

  const handleSearch = () => {
    getUnitOfMeasures(searchRef.current.value, currentPage);
  };

  const handlePagination = (event) => {
    currentPage = event.page + 1;
    setFirst(event.first);
    setRows(event.rows);
    getUnitOfMeasures(searchRef.current.value, currentPage);
  };

  return (
    <div>
      <SetupPage
        title="Unit Of Measures"
        description="Manage units of measure for ingredients, supplier items, and finished products."
        searchPlaceholder="Search units by name"
        searchRef={searchRef}
        onSearch={handleSearch}
        actions={[
          { label: "Add Unit", onClick: openAddUnitOfMeasureSlideOver },
          auditHistoriesSetupAction("unit-of-measure"),
        ]}
        loading={loading}
        tableColumns={["Name"]}
        totalRecords={unitOfMeasures.total}
        first={first}
        rows={rows}
        onPageChange={handlePagination}
      >
        <SetupTable columns={["Name"]} emptyText="No units of measure found.">
          {unitOfMeasures.data?.map((item, index) => (
            <tr key={item.id} className="transition hover:bg-[#F6F8FB]/80">
              <SetupTd muted={false}>{item.name}</SetupTd>
              <SetupActions>
                <button
                  type="button"
                  onClick={() => viewUnitOfMeasureDetails(item, index)}
                  className="inline-flex min-w-[68px] justify-center rounded-lg border border-[#E2E8F0] bg-white px-3 py-1.5 text-sm font-semibold text-[#0F172A] shadow-sm transition hover:border-[#2563EB] hover:bg-[#EFF6FF] hover:text-[#2563EB]"
                >
                  Edit
                </button>
                <AuditActionLink
                  slug="unit-of-measure"
                  id={item.id}
                  name={item.name}
                  className="ml-2"
                />
              </SetupActions>
            </tr>
          ))}
        </SetupTable>
      </SetupPage>
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(UnitOfMeasures),
);
